import { render, staticRenderFns } from "./DialogOverlay.vue?vue&type=template&id=77e2e6ea&scoped=true&"
import script from "./DialogOverlay.vue?vue&type=script&lang=ts&"
export * from "./DialogOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./DialogOverlay.vue?vue&type=style&index=0&id=77e2e6ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e2e6ea",
  null
  
)

export default component.exports